import { forwardRef } from 'react'
import type { TextareaHTMLAttributes } from 'react'
import { FormField, inputBaseStyles } from './FormField'

interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'required'> {
  label?: string
  error?: string
  helperText?: string
  required?: boolean
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helperText, className = '', required, rows = 4, ...props }, ref) => {
    return (
      <FormField label={label} error={error} helperText={helperText} required={required} htmlFor={props.id}>
        <textarea
          ref={ref}
          className={inputBaseStyles(error, `resize-none ${className}`)}
          aria-required={required}
          rows={rows}
          {...props}
        />
      </FormField>
    )
  }
)

Textarea.displayName = 'Textarea'

export default Textarea
